import { render, staticRenderFns } from "./tbView.vue?vue&type=template&id=3f1b2f0d"
import script from "./tbView.vue?vue&type=script&lang=js"
export * from "./tbView.vue?vue&type=script&lang=js"
import style0 from "./tbView.vue?vue&type=style&index=0&id=3f1b2f0d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports